import { IComponentOptions } from "angular";

export const DynamicAssigneeTooltipComponent: IComponentOptions = {
  template: require("./dynamic-assignee-tooltip.component.html"),
  bindings: {
    assigneeIds: "<",
    avatarSize: "<",
  },
};
